import { render, staticRenderFns } from "./Pb2.vue?vue&type=template&id=e70b9db4&scoped=true"
import script from "./Pb2.vue?vue&type=script&lang=js"
export * from "./Pb2.vue?vue&type=script&lang=js"
import style0 from "./Pb2.vue?vue&type=style&index=0&id=e70b9db4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e70b9db4",
  null
  
)

export default component.exports